import { createGlobalStyle } from 'styled-components';
import colors from 'constants/styles/colors';

export const GlobalStyle = createGlobalStyle`
  html {
    box-sizing: border-box;
  }
  *, *:before, *:after {
    font-family: 'Roboto', sans-serif;
    box-sizing: inherit;
    margin: 0;
    padding: 0;
  }
  body {
    font-family: 'Roboto', sans-serif;
    color: ${colors.textDefault};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
  }
  `;
